import { createRouter, createWebHistory } from "vue-router";
import Login from "../views/Login.vue";
import Home from "../views/Home.vue";
import Vacancy from "../views/Vacancy.vue";
import Company from "../views/Company.vue";
import Registration from "../views/Registration.vue";
import RegisterEmail from "../views/RegisterEmail.vue";
import ResetPassword from "../views/ResetPassword.vue";
import RegisterPhone from "../views/RegisterPhone.vue";
import Feed from "../views/Feed.vue"; 
import UserService from "../api/UserService.js";
import EmailVerified from "../views/EmailVerified.vue";
import EmailVerification from "../views/EmailVerification.vue";
import Connect from "../views/Connect.vue";
import Dialogs from "../views/Dialogs.vue";
import MDialogs from "../views/MDialogs.vue";
import User from "../views/User.vue";
import Profile from "../views/Profile.vue";
import ProfileHashtags from "../views/ProfileHashtags.vue"; 
import ProfileConsultant from "../views/ProfileConsultant.vue";
import Favorites from "../views/Favorites.vue";
import MyVacancies from "../views/MyVacancies.vue";
import MyEvents from "../views/MyEvents.vue";
import CreateVacancy from "../views/CreateVacancy.vue";
import EditVacancy from "../views/EditVacancy.vue";
import EditMyVacancy from "../views/EditMyVacancy.vue";
import EditCompany from "../views/EditCompany.vue";
import AdminEditCompany from "../views/AdminEditCompany.vue";
import ForInvestors from "../views/ForInvestors.vue";
import Events from "../views/Events.vue";
import Friends from "../views/Friends.vue";
import Freelance from "../views/Freelance.vue";
import CompaniesSubscriptions from "../views/CompaniesSubscriptions.vue";
import Questions from "../views/Questions.vue";
import Event from "../views/Event.vue";
import PaymentSuccess from "../views/PaymentSuccess.vue";
import PaymentFailure from "../views/PaymentFailure.vue";
import AdminTelegramTopics from "../views/AdminTelegramTopics.vue";
import CreateCompany from "../views/CreateCompany.vue";
import ContentPostingTerms from '../views/ContentPostingTerms.vue'
import CreateEvent from "../views/CreateEvent.vue";
import EditEvent from "../views/EditEvent.vue";
import Support from "../views/Support.vue";
import MChat from "../views/MChat.vue";
import MProfile from "../views/MProfile.vue";
import MProfileGeneral from "../components/mobile-profile/MProfileGeneral.vue";
import MProfileSkills from "../components/mobile-profile/MProfileSkills.vue";
import MProfileCompany from "../components/mobile-profile/MProfileCompany.vue";
import MProfileResume from "../components/mobile-profile/MProfileResume.vue";
import MProfileSocial from "../components/mobile-profile/MProfileSocial.vue";
import MProfileProfessionalLinks from "../components/mobile-profile/MProfileProfessionalLinks.vue"; 
import MProfilePremium from "../components/mobile-profile/MProfilePremium.vue";
import MProfileOther from "../components/mobile-profile/MProfileOther.vue";
import MProfileAccount from "../components/mobile-profile/MProfileAccount.vue";
import AccountIsFrozen from "../views/AccountIsFrozen.vue";
import Advantages from "../views/Advantages.vue";
import AdminPendingVacancies from "../views/AdminPendingVacancies.vue";
import AdminPendingEvents from "../views/AdminPendingEvents.vue";
import AdminVacancyDrafts from "../views/AdminVacancyDrafts.vue";
import AdminEditVacancy from "../views/AdminEditVacancy.vue";
import CompanyStructure from "../views/CompanyStructure.vue";

import { getAuth, onAuthStateChanged } from "firebase/auth";
import "../utils/firebase";

const routes = [
    { path: "/", name: "Home", component: Home },
    { path: "/admin-pending-vacancies", name: "AdminPendingVacancies", component: AdminPendingVacancies },
    { path: "/admin-pending-events", name: "AdminPendingEvents", component: AdminPendingEvents },
    { path: "/login", name: "Login", component: Login },
    { path: "/advantages", name: "Advantages", component: Advantages },
    { path: "/email-verified", name: "EmailVerified", component: EmailVerified },
    { path: "/email-verification", name: "EmailVerification", component: EmailVerification },
    { path: "/account-is-frozen", name: "AccountIsFrozen", component: AccountIsFrozen },
    { path: "/reset-password", name: "ResetPassword", component: ResetPassword },
    { path: "/feed", name: "Feed", component: Feed },
    { path: "/connect", name: "Connect", component: Connect },
    { path: "/dialogs", name: "Dialogs", component: Dialogs },
    { path: "/m-dialogs", name: "MDialogs", component: MDialogs },
    { path: "/home", name: "HomeAlias", component: Home },
    { path: "/registration", name: "Registration", component: Registration },
    { path: "/register-email", name: "RegisterEmail", component: RegisterEmail },
    { path: "/register-phone-auth", name: "RegisterPhone", component: RegisterPhone },
    { path: "/vacancy/:vacancyId", name: "Vacancy", component: Vacancy, props: true },
    { path: "/company/:companyId", name: "Company", component: Company, props: true },
    { path: "/profile", name: "Profile", component: Profile},
    { path: '/profile/hashtags', name: 'ProfileHashtags', component: ProfileHashtags },
    { path: '/profile/consultant', name: 'ProfileConsultant', component: ProfileConsultant },
    { path: '/favorites', name: 'Favorites', component: Favorites },
    { path: "/user/:id", name: "User", component: User, props: true },
    { path: "/my-vacancies", name: "MyVacancies", component: MyVacancies },
    { path: "/my-events", name: "MyEvents", component: MyEvents },
    { path: "/create-vacancy", name: "CreateVacancy", component: CreateVacancy },
    { path: "/create-event", name: "CreateEvent", component: CreateEvent },
    { path: "/edit-vacancy/:id", name: "EditVacancy", component: EditVacancy, props: true },
    { path: '/edit-my-vacancy/:id', name: 'EditMyVacancy', component: EditMyVacancy, props: true},
    { path: "/edit-company/:companyId", name: "EditCompany", component: EditCompany, props: true },
    { path: "/admin-edit-company/:companyId", name: "AdminEditCompany", component: AdminEditCompany, props: true },
    { path: '/for-investors', name: 'ForInvestors', component: ForInvestors},
    { path: '/privacy-policy', component: () => import('../views/PrivacyPolicy.vue')},
    { path: '/terms-of-use', component: () => import('../views/TermsOfUse.vue') },
    { path: '/:pathMatch(.*)*', name: 'Error404', component: () => import('../views/Error404.vue')},
    { path: '/admin-panel', name: 'AdminPanel', component: () => import('../views/AdminPanel.vue') },
    { path: '/admin-telegram-topics', name: 'AdminTelegramTopics', component: AdminTelegramTopics },
    { path: "/all-companies", name: "AllCompanies", component: () => import("../views/AllCompanies.vue") },
    { path: "/all-companies-admin", name: "AllCompaniesAdmin", component: () => import("../views/AllCompaniesAdmin.vue") },
    { path: "/events", name: "Events", component: Events }, 
    { path: "/friends", name: "Friends", component: Friends },
    { path: "/freelance", name: "Freelance", component: Freelance },
    { path: "/subscriptions", name: "CompaniesSubscriptions", component: CompaniesSubscriptions },
    { path: "/questions", name: "Questions", component: Questions },
    { path: "/event/:eventId", name: "event", component: Event, props: true },
    { path: "/payment/success", name: "PaymentSuccess", component: PaymentSuccess },
    { path: "/payment/fail", name: "PaymentFail", component: PaymentFailure },
    { path: '/:pathMatch(.*)*',  name: 'Error404',  component: () => import('../views/Error404.vue') },
    { path: "/create-company", name: "CreateCompany", component: CreateCompany },
    { path: '/publication-policy', name: 'ContentPostingTerms', component: ContentPostingTerms},
    { path: "/edit-event/:id", name: "EditEvent", component: EditEvent, props: true },
    { path: "/support", name: "Support", component: Support },
    { path: "/m-chat", name: "MChat", component: MChat },
    { path: "/m-profile", name: "MProfile", component: MProfile },
    { path: "/m-profile-general", name: "MProfileGeneral", component: MProfileGeneral },
    { path: "/m-profile-skills", name: "MProfileSkills", component: MProfileSkills },
    { path: "/m-profile-company", name: "MProfileCompany", component: MProfileCompany },
    { path: "/m-profile-resume", name: "MProfileResume", component: MProfileResume },
    { path: "/m-profile-social", name: "MProfileSocial", component: MProfileSocial },
    { path: "/m-profile-professional-links", name: "MProfileProfessionalLinks", component: MProfileProfessionalLinks },
    { path: "/m-profile-premium", name: "MProfilePremium", component: MProfilePremium },
    { path: "/m-profile-other", name: "MProfileOther", component: MProfileOther },
    { path: "/m-profile-account", name: "MProfileAccount", component: MProfileAccount },
    { path: "/admin-vacancy-drafts", name: "AdminVacancyDrafts", component: AdminVacancyDrafts },
    { path: "/admin-edit-vacancy/:vacancyId", name: "AdminEditVacancy", component: () => import("../views/AdminEditVacancy.vue")},
    { path: "/admin-instagram-drafts", name: "AdminInstagramDrafts", component: () => import( "../views/AdminInstagramDrafts.vue"), meta: {
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
    {
      path: "/digest/:date?",
      name: "DigestVacancies",
      component: () => import("../views/DigestVacancies.vue"),
      meta: { requiresAuth: false },
    },
    { path: "/company/:companyId/structure", name: "CompanyStructure", component: () => import("../views/CompanyStructure.vue"), props: true }
  ];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const getFirebaseUser = () => {
    const auth = getAuth();
  
    return new Promise((resolve) => {
      if (auth.currentUser) {
        resolve(auth.currentUser);
        return;
      }
  
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        unsubscribe();
        resolve(user);
      });
    });
  };

  router.beforeEach(async (to, from, next) => {
    console.log("🛠 Навигация:", to.path);
  
    const firebaseUser = await getFirebaseUser();
  
    const guestOnlyRoutes = [
      "/",
      "/home",
      "/login",
      "/register-email",
      "/register-phone-auth"
    ];
  
    if (!firebaseUser) {
      sessionStorage.removeItem("session_status");
  
      if (to.path === "/feed") {
        return next("/");
      }
  
      return next();
    }
  
    const userId = firebaseUser.uid;
  
    let sessionData = sessionStorage.getItem("session_status");
  
    if (!sessionData || to.path === "/registration") {
      const { isValid, isRegistrationComplete } =
        await UserService.validateSession(userId);
  
      sessionData = JSON.stringify({
        isValid,
        isRegistrationComplete
      });
  
      if (isValid && isRegistrationComplete) {
        sessionStorage.setItem("session_status", sessionData);
      }
    }
  
    const { isValid, isRegistrationComplete } = JSON.parse(sessionData);
  
    if (!isValid) {
      sessionStorage.removeItem("session_status");
      return next("/");
    }
  
    if (!isRegistrationComplete) {
      if (to.path !== "/registration") {
        return next("/registration");
      }
  
      return next();
    }
  
    if (guestOnlyRoutes.includes(to.path) || to.path === "/registration") {
      return next("/feed");
    }
  
    return next();
  });

export default router;